<template>
  <div class="casco-section">
    <casco-calculator
      v-if="!isSuccessConfirmation"
      @updateAnswers="updateCascoInfo"
      @updateContactInfo="updateContactInfo"
      @confirmCasco="confirmCasco"
      @trackEvent="eventTracking"
    />
    <div v-else class="d-flex flex-column align-center justify-center confirmation-box">
      <div class="confirmation-text">
        Mulțumim! Vă vom contacta cât mai curând!
      </div>
      <div class="mt-5">
        <v-btn
          color="#df0100"
          class="base-button"
          depressed
          tile
          dark
          large
          @click="resetForm"
        >
          Începe de la început
        </v-btn>
      </div>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </div>
</template>

<script>
import CascoCalculator from '@/components/casco/CascoCalculator';
import { dataLayerPost, postToTelegram } from '@/_utils/helpers';
import { CONSTANTS } from '@/_utils/static-data';

export default {
  name: 'CascoForm',
  components: { CascoCalculator },
  data() {
    return {
      loading: false,
      validCasco: false,
      validContact: false,
      isSuccessConfirmation: false,
      cascoAnswers: [],
      contactData: []
    };
  },
  methods: {
    updateCascoInfo({ isValid, answers }) {
      this.validCasco = isValid;
      this.cascoAnswers = answers;
    },
    updateContactInfo({ data, isValid }) {
      this.validContact = isValid;
      this.contactData = data;
    },
    getBillingInfo() {
      if (this.contactData.length > 0) {
        return {
          first_name: this.contactData.find(el => el.value === 'name')?.text,
          last_name: '',
          address_1: '',
          address_2: '',
          city: '',
          state: '',
          postcode: '',
          country: 'MD',
          email: this.contactData.find(el => el.value === 'email')?.text,
          phone: this.contactData.find(el => el.value === 'phone')?.text
        };
      }
      return false;
    },
    getSimpleSectionAnswers() {
      let answerIndex = 1;
      const allAnswers = {};
      for (const cascoAnswer of this.cascoAnswers) {
        if (cascoAnswer) {
          answerIndex++;
          allAnswers[`${answerIndex}_${cascoAnswer.questionText}`] = cascoAnswer.text || cascoAnswer.ids;
        }
      }
      for (const contactAnswer of this.contactData) {
        if (contactAnswer) {
          answerIndex++;
          allAnswers[`${answerIndex}_Contact-${contactAnswer.questionText}`] = contactAnswer.text;
        }
      }
      return allAnswers;
    },
    getMetaAnswers() {
      let answerIndex = 1;
      let allAnswers = [];
      allAnswers = [...allAnswers, ...this.cascoAnswers.map((el) => {
        if (el) {
          answerIndex++;
          return {
            key: `${answerIndex}_${el.questionText}`,
            value: el.text || JSON.stringify(el.ids)
          };
        }
        return null;
      })];
      allAnswers = [...allAnswers, ...this.contactData.map((el) => {
        if (el) {
          answerIndex++;
          return {
            key: `${answerIndex}_Contact-${el.questionText}`,
            value: el.text
          };
        }
        return null;
      })];
      return allAnswers;
    },
    async createOrder({ answers }) {
      try {
        const url = 'https://qasig.md/wp-json/wp-calculator/v1/create-order';
        const newOrder = {
          status: 'processing',
          currency: 'MDL',
          billing: this.getBillingInfo(),
          line_items: [
            {
              product_id: 7673,
              total: '0',
              quantity: 1
            }
          ],
          meta_data: answers
        };
        const res = await fetch(url, {
          method: 'POST',
          body: JSON.stringify(newOrder)
        });
        console.log(res);
        return res.json();
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async confirmCasco() {
      this.loading = true;
      const metaAnswers = this.getMetaAnswers();
      const res = await this.createOrder({
        answers: metaAnswers
      });
      const billingInfo = this.getBillingInfo();
      const firstName = billingInfo.first_name;
      const phone = billingInfo.phone;
      await postToTelegram(`COMANDA NOUA%0AId: ${res.id};%0ATip: CASCO;%0A%0ANume: ${firstName};%0ATelefon: ${phone};`);
      this.eventTracking({ eventName: CONSTANTS.cascoQuoteRequest });
      if (res?.id && res?.order_key) {
        this.isSuccessConfirmation = true;
      } else {
        this.$toasted.error('Ceva n-a mers bine! Vă rugăm să verificați datele introduse');
      }
      this.loading = false;
    },
    resetForm() {
      this.validCasco = false;
      this.validContact = false;
      this.cascoAnswers = [];
      this.contactData = [];
      this.isSuccessConfirmation = false;
    },
    eventTracking({ eventName, payload = {} }) {
      try {
        const metaAnswers = this.getMetaAnswers();
        setTimeout(() => {
          dataLayerPost(eventName, {
            answers: metaAnswers,
            ...payload
          });
        }, 500);
      } catch (e) {
        console.log(e);
      }
    },
  }
};
</script>

<style scoped>
.confirmation-box {
  height: 400px;
}
.confirmation-text {
  font-size: 18px;
  font-weight: 500;
  text-align: center;
}
</style>
